import React from 'react';
import PropTypes from 'prop-types';
import { AVAILABLE_LOCALES } from '%app/js/common/components/material/constants';
import CommonErrorMapper, { TranslationsErrorMapper } from './ErrorMapper';
import extractErrors from '../service/extractErrors';

const ErrorList = ({ errors }) => {
    if (Array.isArray(errors)) {
        return <CommonErrorMapper errors={errors} />;
    }

    const extractedErrors = extractErrors(errors, AVAILABLE_LOCALES.length);
    if (Array.isArray(extractedErrors)) {
        return <CommonErrorMapper errors={extractedErrors} />;
    }

    return <TranslationsErrorMapper errors={extractedErrors} />;
};

ErrorList.propTypes = {
    errors: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.object]).isRequired,
};

export default ErrorList;
